import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MainService } from 'src/app/services/main.service';
import { UtilsService } from 'src/app/services/utils.service';

import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-modal-massive-charge',
  templateUrl: './modal-massive-charge.component.html',
  styleUrls: ['./modal-massive-charge.component.scss']
})
export class ModalMassiveChargeComponent implements OnInit {

  checks: boolean[] = [];
  permissions: any = [];
  expandedIndex = 0;
  permissionsId: any = [];
  formDataFile: any;
  importErrors: string[] = [];
  importMessage: string = '';

  dataForm: FormGroup = new FormGroup({
    name_role: new FormControl('', Validators.required),
    display_name_role: new FormControl('', Validators.required),
  });

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private uService: UtilsService,
    private toast: ToastrService,
    private mService: MainService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ModalMassiveChargeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ){
  }

  getUrl(): string{
    return this.uService.getUrl();
  }

  downloadTemplate(){
    this.mService.get_requestBlob('assets/import-template')
    .subscribe((resp: any)=>{
      if(resp && resp.type === 'application/json'){
        resp.text().then((text: string) => {
          this.toast.error(JSON.parse(text)?.message || 'No se pudo descargar la plantilla.', 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        });
      }else if(resp && resp.size > 0){
        const blob = new Blob([resp], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const anchor = document.createElement('a');
        anchor.href = window.URL.createObjectURL(blob);
        anchor.download = 'PLANTILLA_ACTIVOS.xlsx';
        anchor.click();
      }else{
        this.toast.error('No se pudo descargar la plantilla.', 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
      }
    });
  }

  massiveCharge(event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const formData = new FormData();
      formData.append('file', file);
      this.formDataFile = formData;
    }
    this.importErrors = [];
    this.importMessage = '';
  }

  sendData(){
    if(!this.formDataFile){
      this.importMessage = 'No se pudo importar el archivo.';
      this.importErrors = ['Selecciona el archivo Excel de la plantilla antes de presionar Aceptar.'];
      return;
    }

    this.mService.post_request(`assets/bulk-import`, this.formDataFile).subscribe((resp: any)=>{
      if(resp.status){
        this.toast.success(resp.message, 'Exito', {timeOut: 5000, progressBar: true, closeButton: true});
        this.dismiss();
      }else{
        // Los errores se listan dentro del modal (fila, columna y valor); un toast por error tapaba la pantalla.
        this.importMessage = resp?.message || 'No se pudo importar el archivo.';
        this.importErrors = resp?.errors || [];
        this.toast.error(this.importMessage, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
      }
    });
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
  }

  dismiss(data?) {
    this.dialogRef.close( null );
  }
}

